export default __webpack_public_path__ + "static/media/ico-twitter.6eea0b06.svg";